import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de4e0fe59a5142/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/node_modules/next/dist/client/link.js");
